module.exports = "pegasus/assets/email1-column-14.png";